import { NotificationTag } from "@/components/commons/notification/NotificationTag";
import { TNotificationType } from "@/features/dashboard/constants/notificationTab";
import { background } from "@/theme/colors";
import { FCC } from "@/types/common";
import { Stack, Typography } from "@mui/material";

export type TNotificationProps = {
  title: string;
  type: TNotificationType;
};

export const Notification: FCC<TNotificationProps> = ({ title, type, children }) => {
  return (
    <Stack p={3} gap={3} bgcolor={background.white}>
      <Stack direction="row" alignItems="center" gap={1}>
        <Typography variant="sub16Semi">{title}</Typography>
        <NotificationTag type={type}></NotificationTag>
      </Stack>
      {children}
    </Stack>
  );
};
